import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import '@shoelace-style/shoelace/dist/components/radio-group/radio-group';
import '@shoelace-style/shoelace/dist/components/radio-button/radio-button';
import { emit } from '@amityeko/pbc-core/dist/utilities/event';
import '../typography/tg-label-two';
import styles from './styles';
/**
 * @dependency tg-label-two
 *
 * @event {{ selectedColor }} amityeko-change - Emmited when selected color is changed.
 */
export default class AmityekoColorSelector extends LitElement {
    constructor() {
        super(...arguments);
        this.name = 'color-selector';
        this.colors = [];
        this.hasAsterisk = false;
        // TODO: To add logic (only visual added)
        this.required = false;
    }
    /** Resets color selector state */
    reset() {
        this.selectedColor = this.defaultColor;
    }
    firstUpdated() {
        this.selectedColor = this.defaultColor;
        if (this.selectedColor) {
            emit(this, 'amityeko-change', { detail: { selectedColor: this.selectedColor } });
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('defaultColor')) {
            this.selectedColor = this.defaultColor;
            if (this.selectedColor) {
                emit(this, 'amityeko-change', { detail: { selectedColor: this.selectedColor } });
            }
        }
    }
    _onChange(e, color) {
        e.stopPropagation();
        this.selectedColor = color;
        emit(this, 'amityeko-change', { detail: { selectedColor: color } });
    }
    _renderRadioButton(colorValue) {
        return html `
      <sl-radio-button
        .name=${this.name}
        .value=${colorValue}
        @click=${(e) => this._onChange(e, colorValue)}
        class=${classMap({
            'button--checked': this.selectedColor === colorValue,
            'button--white': this.selectedColor === '#FFFFFF' ||
                this.selectedColor === '#ffffff' ||
                this.selectedColor === 'white',
        })}
        style=${styleMap({
            '--private-button-color': colorValue,
        })}
      >
      </sl-radio-button>
    `;
    }
    render() {
        if (this.colors.length === 0)
            return null;
        return html `
      <sl-radio-group>
        ${this.label &&
            html `<amityeko-tg-label-two part="label"
          >${this.label} ${this.required && this.hasAsterisk ? '*' : null}</amityeko-tg-label-two
        >`}
        <div class="radio-buttons-wrapper">
          ${repeat(this.colors, color => color, color => this._renderRadioButton(color))}
        </div>
      </sl-radio-group>
    `;
    }
}
AmityekoColorSelector.styles = styles;
__decorate([
    property()
], AmityekoColorSelector.prototype, "name", void 0);
__decorate([
    property({ type: Array })
], AmityekoColorSelector.prototype, "colors", void 0);
__decorate([
    property()
], AmityekoColorSelector.prototype, "defaultColor", void 0);
__decorate([
    property()
], AmityekoColorSelector.prototype, "label", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoColorSelector.prototype, "hasAsterisk", void 0);
__decorate([
    property({ type: Boolean })
], AmityekoColorSelector.prototype, "required", void 0);
__decorate([
    state()
], AmityekoColorSelector.prototype, "selectedColor", void 0);
if (!customElements.get('amityeko-color-selector')) {
    customElements.define('amityeko-color-selector', AmityekoColorSelector);
}
//# sourceMappingURL=index.js.map